export default __webpack_public_path__ + "static/media/room-polen-main.5b9d2261.jpg";